<template>
    <alert-modal
        :title="$t('CHANGE_WARNING_TITLE')"
        :primaryCTAText="$t('ACTION_CONFIRM')"
        :secondaryCTAText="$t('ACTION_CANCEL')"
        @close="close"
        @cancel="close"
        @confirm="confirm"
        @overlayClick="close"
    >
        <div class="cz2__modal-popup__copy">
            {{$t('CHANGE_WARNING_BODY')}}
        </div>
    </alert-modal>
</template>

<script>
    import AlertModal from './ui/AlertModal.vue';

    export default {
        components: {
            AlertModal,
        },

        computed: {
            changeWarningShown() {
                return this.$store.state.changeWarningShown;
            },
        },

        methods: {
            close() {
                if (this.changeWarningShown) {
                    if (this.changeWarningShown.cancel) {
                        this.changeWarningShown.cancel();
                    }
                }

                this.$store.dispatch('showChangeWarning', null);
            },

            confirm() {
                if (this.changeWarningShown) {
                    if (this.changeWarningShown.confirm) {
                        this.changeWarningShown.confirm();
                    }
                }

                this.$store.dispatch('showChangeWarning', null);
            },
        },
    };
</script>
